module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h3', [_vm._v("Commissions Reports")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md4": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.users,
      "label": "Select Case Manager"
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Start Date",
            "prepend-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          model: {
            value: (_vm.fromDate),
            callback: function($$v) {
              _vm.fromDate = $$v
            },
            expression: "fromDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "End Date",
            "prepend-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          model: {
            value: (_vm.toDate),
            callback: function($$v) {
              _vm.toDate = $$v
            },
            expression: "toDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.completedCases,
      "headers": _vm.analyticHeaders,
      "loading": _vm.loading,
      "expand": _vm.expand,
      "item-key": "id",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "grey lighten-2",
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.manager_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.cases.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(Number(props.item.commission))))])])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-data-table', {
          attrs: {
            "items": props.item.cases,
            "hide-actions": "",
            "hide-headers": ""
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return [_c('td', [_vm._v("Case ID: " + _vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v("Case Wake Date: " + _vm._s(props.item.wake_end))]), _vm._v(" "), _c('td', [(props.item.services.length) ? _c('span', [_vm._v("Services: ")]) : _vm._e(), _vm._v(_vm._s(_vm._.map(props.item.services, 'service.name').join(',')))]), _vm._v(" "), _c('td', [_vm._v("Location of wake: " + _vm._s(_vm.getWakeLocation(props.item.answers)))]), _vm._v(" "), _c('td', [_vm._v("Commissions: " + _vm._s(Math.round(Number(props.item.commissions))))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('div', {
          staticClass: "align-right"
        }, [_c('v-btn', {
          on: {
            "click": function($event) {
              return _vm.exportToCSV(props.item.cases)
            }
          }
        }, [_vm._v("Export to CSV")])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25af1598","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources/Analytics.vue
// module id = 969
// module chunks = 1